import { Directive, HostListener } from '@angular/core'

/**
 * Directive to disable the default mouse wheel behaviour on number inputs.
 */
@Directive({
  selector: 'input[type="number"]',
  standalone: false,
})
export class DisableNumberSpinnerDirective {
  @HostListener('wheel', ['$event'])
  onWheel(event: WheelEvent): void {
    event.preventDefault()
  }
}
